import ga from './ga.init'

const loadAnalytics = () => {
	if (!globalThis.window.location.host.includes('localhost')) {
		ga.initGoogleAnalytics()
	}
}

export default loadAnalytics
